/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

/**
 * Set query parameters in the URL
 *
 * @param {string} value
 * @param {string} key
 */
window.setQueryParams = function (value, key) {
  /*
   * queryParameters -> handles the query string parameters
   * queryString -> the query string without the fist '?' character
   * re -> the regular expression
   * m -> holds the string matching the regular expression
   */
  var queryParameters = {},
    queryString = location.search.substring(1),
    re = /([^&=]+)=([^&]*)/g,
    m;

  // Creates a map with the query string parameters
  while ((m = re.exec(queryString))) {
    queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
  }

  // Add new parameters or update existing ones
  queryParameters[key] = value;

  /*
   * Replace the query portion of the URL.
   * jQuery.param() -> create a serialized representation of an array or
   *     object, suitable for use in a URL query string or Ajax request.
   */
  location.search = $.param(queryParameters); // Causes page to reload
};
